export class RightMenuView {
  fields = document.querySelectorAll('.player');
  container = document.querySelector(
    '.cards-container',
  )! as HTMLImageElement;

  containerLabel = document.getElementById("cards")!


}
